import React, { useEffect, useState } from "react";
import Handler from "../../Helpers/Components/Handler";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "../../Helpers/Components/Modal";
import { LuPhone, LuUsers } from "react-icons/lu";
import { HiOutlineMailOpen } from "react-icons/hi";
import { FaAngleRight, FaEye, FaEyeSlash, FaIdCard, FaPhone, FaRegUser } from "react-icons/fa6";
import { MdOutlineDocumentScanner } from "react-icons/md";
import { BiLogoGmail } from "react-icons/bi";
import Aadhaar from "./Aadhaar";
import DL from "./DL";
import Passport from "./Passport";
import { RxCross2 } from "react-icons/rx";
import { TbCheck } from "react-icons/tb";
import { getCookie } from "../../Helpers/Utils";

const View = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState({});
    const [customers, setCustomer] = useState({});
    const [profile, setProfile] = useState("profile");
    const [rejected, setRejected] = useState({ modal: false, reason: "", accept: false, requestKey: "", element: null });
    const [view, setView] = useState({ modal: false, requestKey: "", element: null });
    const [has, setHas] = useState({ hasProfile: false, hasKyc: false, hasSecKyc: false });
    const [show, setShow] = useState({ phone: false, email: false })
    const person = getCookie('person')
    const REQUEST_KEYS = {
        profile: {
            profile: { label: "Profile Image", icon: <FaRegUser />, smallLabel: "IDENTITY" },
            altNumber1: { label: "Alt Number 1", icon: <FaPhone />, smallLabel: "VERIFICATION" },
            altNumber2: { label: "Alt Number 2", icon: <FaPhone />, smallLabel: "VERIFICATION" },
            emailId: { label: "Email", icon: <BiLogoGmail />, smallLabel: "VERIFICATION" }
        },
        kyc: {
            dl: { label: "Driving License", icon: <FaIdCard />, smallLabel: "KYC" },
            aadhaar: { label: "Aadhaar", icon: <FaIdCard />, smallLabel: "KYC" },
            passport: { label: "Passport", icon: <FaIdCard />, smallLabel: "KYC" }
        },
        seckyc: {
            profile2: { label: "Profile Image", icon: <FaRegUser />, smallLabel: "IDENTITY" },
            dl2: { label: "Driving License", icon: <FaIdCard />, smallLabel: "KYC" },
            aadhaar2: { label: "Aadhaar", icon: <FaIdCard />, smallLabel: "KYC" },
            passport2: { label: "Passport", icon: <FaIdCard />, smallLabel: "KYC" }
        }
    };
    const getRequestValue = (item, key) => {
        const data = item?.data;
        switch (key) {
            case "profile":
            case "profile2":
                return "";
            case "altNumber1":
            case "altNumber2":
                return `${data?.code || ""} ${data?.phoneNumber || ""}`.trim();
            case "emailId": return data?.emailId || "";
            case "dl":
            case "dl2":
                {
                    const number = data?.dlNo || "";
                    const validUpto = data?.validUpto || "";
                    if (number && validUpto) return `${number} - ${validUpto}`;
                    return number || validUpto || "";
                }
            case "aadhaar":
            case "aadhaar2":
                return data?.aadhaarNo || "";
            case "passport":
            case "passport2":
                {
                    const passport = data?.passport || data?.passport2 || "";
                    const validUpto = data?.validUpto || "";
                    if (passport && validUpto) return `${passport} - ${validUpto}`;
                    return passport || validUpto || "";
                }
            default: return "";
        }
    };
    const getRequestItems = (type) => {
        const allowedKeys = Object.keys(REQUEST_KEYS?.[type] || {});
        return (details?.requests || []).filter((item) => allowedKeys.includes(item?.requestKey));
    };
    const reject = async () => {
        if (!rejected?.reason) return toast.error("Reason is required");
        setLoading(true);
        const response = await Handler({ method: "PATCH", url: `/customer/request/updation/${id}`, data: { reason: rejected?.reason, accept: rejected?.accept, requestKey: rejected?.requestKey } });
        if (response?.success) {
            toast.success(response.message);
            setRejected({ modal: false, reason: "", accept: false, requestKey: "", element: null });
            getDetails();
        } else {
            toast.error(response.message);
        }
        setLoading(false);
    };
    const getDetails = async () => {
        setLoading(true);
        const response = await Handler({ method: "GET", url: `/customer/request/${id}` });
        if (response?.success) {
            setDetails(response?.data || {});
            const customer = await Handler({ url: `/customer/details/view/${response?.data?.customerId}`, method: "GET" });
            if (customer?.success) setCustomer(response?.data?.customerData || {});
        } else {
            setDetails({});
            setCustomer({});
        }
        setLoading(false);
    };
    const RequestCard = ({ item, config, requestKey, index }) => {
        const isUploaded = item?.keyStatus === "Uploaded";
        const isPending = item?.keyStatus === "Pending";
        const isApproved = item?.keyStatus === "Approved";
        const isKyc = ["dl", "aadhaar", "passport", "dl2", "aadhaar2", "passport2"].includes(requestKey);
        return (
            <div className="col-lg-6 col-md-12 my-2" key={index}>
                <div className="profile-right-small-cards">
                    <div className="profile-right-top-title mb-2">
                        <div className="d-flex flex-column">
                            <div className="profile-right-small-title">{config?.smallLabel}</div>
                            <div className="profile-right-title-text d-flex align-items-center gap-1">{config?.label} {isApproved && isKyc && (<button className="btn border-0 p-0" onClick={() => setView({ modal: true, requestKey, element: item })}><FaEye className="fs-6" fill="var(--primary)" /></button>)} </div>
                        </div>
                        <div>
                            {isPending && (<div className="badge d-flex align-items-center text-bg-danger border-rounded rounded-pill"> Pending </div>)}
                            {isApproved && (<div className="badge d-flex align-items-center text-bg-success border-rounded rounded-pill"> Approved </div>)}
                            {isUploaded && (<div className="badge d-flex align-items-center text-bg-warning border-rounded rounded-pill"> Uploaded </div>)}
                        </div>
                    </div>
                    <div className="mb-3">{getRequestValue(item, requestKey)}</div>
                    <div className="dotted-lines">{(config?.icon)}</div>
                    {details?.rejectedDatas?.length && details?.rejectedDatas?.find(ele => ele?.requestKey === requestKey) && isPending ? <div className="mt-2 profile-reason-text">Rejected: {details?.rejectedDatas?.find(ele => ele?.requestKey === requestKey)?.reason || "reason"}</div> : ""}
                    {isUploaded && (
                        <div className="d-flex gap-2">
                            <button className="btn profile-right-btn" onClick={() => setRejected({ modal: true, reason: "", accept: true, requestKey, element: item })}><TbCheck /> <span> Approve</span></button>
                            <button className="btn profile-right-btn profile-right-danger-btn" onClick={() => setRejected({ modal: true, reason: "", accept: false, requestKey, element: item })}> <RxCross2 /> <span>Reject</span></button>
                        </div>
                    )}
                </div>
            </div>
        );
    };
    const sendSecretEmail = () => {
        const emailId = customers?.email?.emailId
        if (show?.email) return emailId
        const lastFour = emailId?.split("@")
        return lastFour[0]?.slice(-4)?.padStart(lastFour[0]?.length, '*') + '@' + lastFour[1]
    }
    const sendSecretNumber = () => {
        const phoneNumber = customers?.phone?.find((ele) => ele.priority === 1)
        if (show?.phone) return phoneNumber?.code + "-" + phoneNumber?.phone
        const lastFour = phoneNumber?.phone?.slice(-4)
        return phoneNumber?.code + "-" + lastFour?.padStart(phoneNumber?.phone?.length, '*')
    }
    useEffect(() => {
        const requestKeys = (details?.requests || []).map((item) => item?.requestKey);
        const profileKeys = Object.keys(REQUEST_KEYS?.profile || {});
        const kycKeys = Object.keys(REQUEST_KEYS?.kyc || {});
        const secKycKeys = Object.keys(REQUEST_KEYS?.seckyc || {});
        const hasProfile = requestKeys.some((key) => profileKeys.includes(key));
        const hasKyc = requestKeys.some((key) => kycKeys.includes(key));
        const hasSecKyc = requestKeys.some((key) => secKycKeys.includes(key));
        setHas({ hasProfile, hasKyc, hasSecKyc });
        if (hasProfile) {
            setProfile("profile");
        } else if (hasKyc) {
            setProfile("kyc");
        } else if (hasSecKyc) {
            setProfile("seckyc");
        }
    }, [details]);
    useEffect(() => { getDetails(); }, []);
    const getProfileHeading = () => {
        switch (profile) {
            case "profile": return "Profile";
            case "kyc": return "KYC";
            case "seckyc": return "Second Customer";
            default: return "";
        }
    };
    return (
        <React.Fragment>
            <div className="row align-items-stretch">
                <div className="col-xl-4 col-lg-12 col-md-6">
                    <div className="profile-left-card">
                        <div className="profile-image-background">
                            <div className="profile-back"></div>
                            <div className="profile-photo-image"><img src={customers?.photo || "https://placehold.co/800?text=Profile"} alt="Profile" /></div>
                        </div>
                        <div className="profile-padding">
                            <div className="profile-view-name mb-0"> {customers?.firstName || ""}{" "} {customers?.lastName || ""}</div>
                            <Link to={`/customer/view/${customers?.customerId}`} className="text-muted text-underline mb-4 d-inline-flex">#{customers?.customerId || ""}</Link>
                            <div className="profile-view-mobile">
                                <div className="profile-view-mobile-text">
                                    <div className="profile-phone-image"><LuPhone style={{ height: "22px", width: "22px" }} /></div>
                                    <div className="flex-1">
                                        <span className="phone-text">Phone Number</span>
                                        <div className="phone-number-text d-flex justify-content-between gap-1 flex-wrap align-items-center"> <span>{customers?.phone?.length ? sendSecretNumber() : "-"}</span> {person === "admin" ? <button className="btn view-btn border-0 p-0" onClick={() => setShow((prev) => ({ ...prev, phone: !show.phone }))}>{show?.phone ? <FaEye /> : <FaEyeSlash />}</button> : ""}</div>
                                    </div>
                                </div>
                                <div className="profile-line"></div>
                                <div className="profile-view-mobile-text">
                                    <div className="profile-phone-image"><HiOutlineMailOpen style={{ height: "22px", width: "22px" }} /></div>
                                    <div className="flex-1">
                                        <span className="phone-text">Email</span>
                                        <div className="phone-number-text d-flex justify-content-between gap-1 flex-wrap align-items-center"> <span>{customers?.email?.emailId ? sendSecretEmail() : "-"}</span> { customers?.email?.emailId && person === "admin" ? <button className="btn view-btn border-0 p-0" onClick={() => setShow((prev) => ({ ...prev, email: !show.email }))}>{show?.email ? <FaEye /> : <FaEyeSlash />}</button> : ""}</div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="profile-preference">Preferences</div>
                                <ul className="profile-ul">
                                    {has?.hasProfile && (
                                        <li>
                                            <button onClick={() => setProfile("profile")} className={profile === "profile" ? "active-profile-btn" : ""}>
                                                <div className="d-flex align-items-center gap-1"> <span className="d-flex"><FaRegUser /></span> <span>Profile</span></div>
                                                <div><FaAngleRight /></div>
                                            </button>
                                        </li>
                                    )}
                                    {has?.hasKyc && (
                                        <li>
                                            <button onClick={() => setProfile("kyc")} className={profile === "kyc" ? "active-profile-btn" : ""}>
                                                <div className="d-flex align-items-center gap-1"> <span className="d-flex"><MdOutlineDocumentScanner /></span> <span>KYC</span></div>
                                                <div><FaAngleRight /></div>
                                            </button>
                                        </li>
                                    )}
                                    {has?.hasSecKyc && (
                                        <li>
                                            <button onClick={() => setProfile("seckyc")} className={profile === "seckyc" ? "active-profile-btn" : ""}>
                                                <div className="d-flex align-items-center gap-1"> <span className="d-flex"><LuUsers /></span> <span>Second Customer</span></div>
                                                <div><FaAngleRight /></div>
                                            </button>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-8 col-lg-12 col-md-6">
                    <div className="profile-right-card">
                        <div className="profile-right-title">{getProfileHeading()}</div>
                        <div className="row align-items-stretch justify-content-start">
                            {getRequestItems(profile).map((item, key) => {
                                const requestKey = item?.requestKey;
                                const config = REQUEST_KEYS?.[profile]?.[requestKey];
                                if (!config) return null;
                                return (<RequestCard key={requestKey} item={item} config={config} requestKey={requestKey} index={key} />);
                            })}
                        </div>
                    </div>

                </div>
            </div>
            <Modal header="Reason" size="lg" centered={true} onShow={rejected?.modal} toggle={() => setRejected({ modal: false, reason: "", accept: false, requestKey: "", element: null })} overlayToggle={() => setRejected({ modal: false, reason: "", accept: false, requestKey: "", element: null })}>
                <div className="modalPhoto">
                    {(rejected?.requestKey === "aadhaar" || rejected?.requestKey === "aadhaar2") && (<Aadhaar rejected={rejected?.element?.data} />)}
                    {(rejected?.requestKey === "dl" || rejected?.requestKey === "dl2") && (<DL rejected={rejected?.element?.data} />)}
                    {(rejected?.requestKey === "passport" || rejected?.requestKey === "passport2") && (<Passport rejected={rejected?.element?.data} />)}
                    <input autoComplete="off" value={rejected?.reason || ""} placeholder="Reason" disabled={loading} className="form-control input-theme text-uppercase" type="text" onChange={(e) => setRejected((prev) => ({ ...prev, reason: e.target.value }))} />
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button disabled={loading} className={`btn btn-sm ${rejected?.accept ? "btn-success" : "btn-danger"}`} onClick={reject}>  {loading ? (<i className="fa-solid fa-spinner fa-spin"></i>) : rejected?.accept ? ("Approve") : ("Reject")} </button>
                </div>
            </Modal>
            <Modal header="Details" size="xl" centered={true} onShow={view?.modal} toggle={() => setView({ modal: false, requestKey: "", element: null })} overlayToggle={() => setView({ modal: false, requestKey: "", element: null })}>
                <div className="modalPhoto">
                    {(view?.requestKey === "aadhaar" || view?.requestKey === "aadhaar2") && (<Aadhaar rejected={view?.element?.data} />)}
                    {(view?.requestKey === "dl" || view?.requestKey === "dl2") && (<DL rejected={view?.element?.data} />)}
                    {(view?.requestKey === "passport" || view?.requestKey === "passport2") && (<Passport rejected={view?.element?.data} />)}
                </div>
            </Modal>
        </React.Fragment>
    );
};

export default View;